import firebase from "firebase";

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyB8lk7_dkAO0cmPP-Dme8jbYPyL60oe-yY",
  authDomain: "todo-app-cp-32947.firebaseapp.com",
  databaseURL: "https://todo-app-cp-32947.firebaseio.com",
  projectId: "todo-app-cp-32947",
  storageBucket: "todo-app-cp-32947.appspot.com",
  messagingSenderId: "154095715452",
  appId: "1:154095715452:web:a23c25f80c10ef2ec6b5f9",
  measurementId: "G-KWR4W0XJFJ",
});

const db = firebaseApp.firestore();

export default db;